import { Task } from 'redux-saga';
import { cancel, fork, put, take, takeEvery, call } from 'redux-saga/effects';
import { fetchCustomerId } from '../api/fetch-customer-id';
import { fetchCustomerId as fetchId } from './actions';

export function* fetchCustomerIdSaga() {
  try {
    const customerId: number = yield call(fetchCustomerId);
    yield put(fetchId.success(customerId));
  } catch (e) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    yield put(fetchId.failure(e));
  }
}

export function* fetchCustomerIdFork() {
  const forked: Task = yield fork(fetchCustomerIdSaga);
  yield take(fetchId.cancel);
  yield cancel(forked);
}

export function* getIdSaga() {
  yield takeEvery(fetchId.request, fetchCustomerIdFork);
}
